import styles from './Portfolio.module.css';
// import Project_1 from '../../images/projects/markup-hw-08_1.1.jpg';
// import Project_2 from '../../images/projects/icecream-team-project_02.1.jpg';
// import Project_3 from '../../images/projects/team-03-pr-film_03.jpg';
// import Project_4 from '../../images/projects/pro-test_04.jpg';
import Project_5 from '../../images/projects/iryna-deutsch.jpg';
import Project_6 from '../../images/projects/uwp_04.jpg';
import Project_7 from '../../images/projects/illia_01.jpg';
import Project_8 from '../../images/projects/the-art-banch_01.jpg';
import Project_9 from '../../images/projects/history-of-malyn.jpg';
// import icon_01 from '../../images/icons/qwik-logo_01.png';

import SpriteFigma from '../../images/icons/tehnology-5.svg';
import SpriteFigmaTailwinQwik from '../../images/icons/tahnology-tailwind-qwik.svg';

const Portfolio = () => {
  return (
    <div className={styles.portfolio}>
      <div className={styles.container}>
        <h1 className={styles.title}>Portfolio team projects</h1>

        <ul className={styles.portfolioBox}>
          <li className={styles.pictures}>
            <p className={styles.text}>HISTORY of Malyn</p>
            <a
              href="https://history-of-malyn.netlify.app"
              target="blank"
              rel="noreferrer"
            >
              <img
                className={styles.picturesImg}
                src={Project_9}
                alt="project the history of malyn"
              />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>The Art Bench</p>
            <a
              href="https://the-art-bench.netlify.app/"
              target="blank"
              rel="noreferrer"
            >
              <img
                className={styles.picturesImg}
                src={Project_8}
                alt="project the art bench"
              />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>Portfolio for my son</p>
            <a
              href="https://illia-shevchenko-resume.netlify.app/"
              target="blank"
              rel="noreferrer"
            >
              <img
                className={styles.picturesImg}
                src={Project_7}
                alt="Portfolio for my son"
              />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>UWP</p>
            <a href="https://uwp.digital/en" target="blank" rel="noreferrer">
              <img
                className={styles.picturesImg}
                src={Project_6}
                alt="project uwp"
              />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>IRYNA-DEUTSCH</p>
            <a
              href="https://iryna-deutsch.netlify.app/"
              target="blank"
              rel="noreferrer"
            >
              <img
                className={styles.picturesImg}
                src={Project_5}
                alt="project IRYNA-DEUTSCH"
              />
            </a>
          </li>

          {/* <li className={styles.pictures}>
            <p className={styles.text}>PRO-TEST</p>
            <a
              href="https://team-project-protest.netlify.app/auth"
              target="blank"
              rel="noreferrer"
            >
              <img
                className={styles.picturesImg}
                src={Project_4}
                alt="project_pro-test"
              />
            </a>

            <span className={styles.overlay}></span>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>FILMOTEKA</p>
            <a
              href="https://vsevolodzharkov.github.io/team-03-pr-film/"
              target="blank"
              rel="noreferrer"
            >
              <img
                className={styles.picturesImg}
                src={Project_3}
                alt="project_filmoteka"
              />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>ICECREAM</p>
            <a
              href="https://vklapan.github.io/icecream-team-project/"
              target="blank"
              rel="noreferrer"
            >
              <img
                className={styles.picturesImg}
                src={Project_2}
                alt="project_icecream"
              />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>WEB-STUDIO Own project</p>
            <a
              href="https://serg-itsh.github.io/goit-markup-hw-08/"
              target="blank"
              rel="noreferrer"
            >
              <img
                className={styles.picturesImg}
                src={Project_1}
                alt="project_web-studio"
              />
            </a>
          </li> */}
        </ul>
        <div className={styles.tehnology}>
          <h2 className={styles.tehnology_text}>
            Use of technologies on projects.
          </h2>

          <div className={styles.icon}>

            <div className={`${styles.iconScale} ${styles.div1}`}>
              <svg className={styles.iconWidth}>
                <use href={`${SpriteFigma}#icon-html-svg`}></use>
              </svg>
            </div>

            <div className={`${styles.iconScale} ${styles.div2}`}>
              <svg className={styles.iconWidth}>
                <use href={`${SpriteFigma}#icon-css-svg`}></use>
              </svg>
            </div>

            <div className={`${styles.iconScale} ${styles.div3}`}>
              <svg className={styles.iconWidth}>
                <use href={`${SpriteFigma}#icon-js-svg`}></use>
              </svg>
            </div>

            <div className={`${styles.iconScale} ${styles.div4}`}>
              <svg className={styles.iconWidth}>
                <use href={`${SpriteFigma}#icon-figma-svg`}></use>
              </svg>
            </div>

            <div className={`${styles.iconScale} ${styles.div5}`}>
              <svg className={styles.iconWidth}>
                <use href={`${SpriteFigma}#icon-react-svg`}></use>
              </svg>
            </div>

            <div className={`${styles.iconScale} ${styles.div6}`}>
              <svg className={styles.iconWidth}>
                <use href={`${SpriteFigma}#icon-node-svg`}></use>
              </svg>
            </div>

            <div className={`${styles.iconScale} ${styles.div7}`}>
              <svg className={styles.iconWidth}>
                <use href={`${SpriteFigmaTailwinQwik}#icon-tailwind-2`}></use>
              </svg>
            </div>

            <div className={`${styles.iconScale} ${styles.div8}`}>
              <svg className={styles.iconWidth}>
                <use href={`${SpriteFigmaTailwinQwik}#icon-qwik-2`}></use>
              </svg>
            </div>

           

            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
